<template>
  <v-container fluid class="pa-0">
    <router-view></router-view>
  </v-container>
</template>


<script>
// import NavTopView from '@/views/NavTopView.vue'
export default {
  components: {
    // NavTopView
  },
};
</script>
    
<style>
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
    